import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons';
import { generatePath, Link } from 'react-router-dom';
import { IconButton, Badge } from '@nexelem/components';
import { NodeIcon } from '../../../../../../../../components/organisms/ProductionPlans/Gantt/components';
import { productionOrderStatusMap } from '../../../../../../ProductionOrders/utils/mappers/productionOrderStatusMap';
import { getAbsolutePath, ROUTES } from '../../../../../../../../routes/config';
import { PRODUCTION_ORDERS_DETAILS_TABS } from '../../../../../../ProductionOrders/ProductionOrdersDetailsPage/DetailsTabs/consts';
import { useCustomTranslation } from '../../../../../../../../hooks';
import { useDateFormatter } from '@nexelem/utils';
import { ProductionOrderStatus } from '@nexelem/api';
import { TaskType } from '@nexelem/graphne-api';
import { useAuthContext } from '../../../../../../../../providers/AuthProvider';
import { PERMS } from '../../../../../../../../routes/permissions';

type ProductionOrderItemProps = {
  id?: number;
  number?: string;
  externalId?: string;
  status?: ProductionOrderStatus;
  dueDate?: string;
  taskType: TaskType;
};

export const ProductionOrderItem = ({
  id,
  number,
  externalId,
  status,
  dueDate,
  taskType,
}: ProductionOrderItemProps) => {
  const { hasPermission } = useAuthContext();
  const dateFormatter = useDateFormatter({});
  const { tWrapper } = useCustomTranslation('products.productionPlan.taskDetailsDrawer');
  const canViewProductionOrderDetails = hasPermission(PERMS.PERM_10);

  if (!id || !number) {
    return null;
  }

  const hasDistinctExternalId = externalId && externalId !== number;
  const displayId = hasDistinctExternalId ? externalId : number;

  return (
    <div className="flex items-center gap-3 border-b border-border-primary py-3 pr-2 pl-4">
      <NodeIcon statusColor={status && productionOrderStatusMap(status)?.color} taskType={taskType} />
      <div className="flex grow flex-col gap-1">
        {hasDistinctExternalId && (
          <span className="text-s11-sb text-text-secondary uppercase">
            {tWrapper('orderId')} {number}
          </span>
        )}
        <span className="flex items-center gap-2 text-s16-sb text-text-primary">
          {displayId} <Badge>{tWrapper('source')}</Badge>
        </span>
        {dueDate && (
          <span className="text-s11-sb text-text-secondary uppercase">
            {tWrapper('due')} {dateFormatter(dueDate)}
          </span>
        )}
        <span className="text-s11-sb text-text-secondary uppercase">{tWrapper('productionOrder')}</span>
      </div>
      {canViewProductionOrderDetails && (
        <Link
          target="_blank"
          to={getAbsolutePath(
            generatePath(ROUTES.productionOrders.details.full, {
              id: id.toString(),
              tab: PRODUCTION_ORDERS_DETAILS_TABS.PRODUCTION_LOTS,
            }),
          )}
        >
          <IconButton Icon={() => <FontAwesomeIcon icon={faArrowUpRightFromSquare} />} size="small" />
        </Link>
      )}
    </div>
  );
};
